module.exports = __webpack_public_path__ + "img/2Y.1.6d942b3d.jpg";